import { Component, AfterViewInit } from '@angular/core';
import { LoadingService } from '../../services/loading.service'
declare var $:any;

@Component({
	selector: 'loading-modal',
	templateUrl: 'loading-modal.html'
})
export class LoadingModalContainer {

	isClose:boolean = true;
	loadingMsg:string = "로딩중";
	constructor(private loadingService:LoadingService){
		loadingService.loadingEmitter.subscribe((flag:boolean) => {
			this.isClose = flag;
		})

		loadingService.loadingEmitter2.subscribe((loadingMsg:string) => {
			this.loadingMsg = loadingMsg;
		})
	}
}


// WEBPACK FOOTER //
// ./src/app/containers/loading/loading-modal.ts